import { render, staticRenderFns } from "./AutomationUserPermissionsTab.vue?vue&type=template&id=6da733d8&scoped=true"
import script from "./AutomationUserPermissionsTab.vue?vue&type=script&lang=js"
export * from "./AutomationUserPermissionsTab.vue?vue&type=script&lang=js"
import style0 from "./AutomationUserPermissionsTab.vue?vue&type=style&index=0&id=6da733d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da733d8",
  null
  
)

export default component.exports